import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { SettingService } from 'src/app/_services/setting.service';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import * as _ from "lodash";
import { element } from 'protractor';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';
declare var $: any;

@Component({
  selector: 'app-project-setting',
  templateUrl: './project-setting.component.html',
  styleUrls: ['./project-setting.component.scss']
})
export class ProjectSettingComponent implements OnInit {

  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Settings',
    data: undefined,
  }
  projectId: string;
  projectData: any;
  projectSettingData: any;
  TestEnvData: Object;
  applicationSettingData: any;
  customSettingData: any;
  dbSettingData: any;
  testEnvSettingData: any;
  submitted: boolean;
  bugLoggingSettingData: any;
  bugDataToEdit: any;
  bugDataValue: any;
  isMasked: boolean;
  settingTestEnvData: any;
  updateSettingData = [];
  PropertyName: any;
  formObj: any;
  bugLoggingUpdate: any;
  updateTestEnvData: boolean = true;
  isInputTypePassword: boolean = false;
  updateApplicationData: boolean;
  updateCustomData: boolean;
  updateDbData: boolean;
  browserType = ["Public", "Private"]
  Browser = ["IE", "MICROSOFTEDGE", "CHROME", "FIREFOX", "CHROMEHEADLESS", "CHROMEEMBEDDED", "PHANTOMJS", "OPERA"];
  bugLogDir = ["JIRA", "TFS", "GITLAB", "BUGZILLA", "TFS_PAT"];
  bugLogggingGroup = ["Auto", "SemiAuto", "Manual"];
  serviceTypeGroup = ["Other", "WEBSERVICE", "SAPISERVICE"];
  reportTypeGroup= ["ALL", "NOTPASS", "PASS", "FAIL", "INCONCLUSIVE"];
  dataView = ["Plain", "Grid"];
  run_mode = ["parallel", "sequential"];
  removeEdit = ["browser_reopen", "test_adapter_type"];
  screenShotOptions = ["ALL", "FAIL", "PASS",  "NOTPASS", "INCONCLUSIVE"]; // change by surendra
  databaseDrivers = ["MongoDriver", "MySQLDriver", "SQLServerDriver", "SQLServerDriverWA","SQLServerDriverAAD", "InfluxDriver", "OracleDriver", "DB2Driver", "CassandraDriver", "HanaDriver", "SnowflakeServerDriver", "AzureSynpaseDriver"];
  driverTypes = ["winium", "winapp", "autogui"];
  mobilePlatform = ["iOS", "Andriod", "FirefoxOS"];
  failRunOptions = [{
    value: 'ALL',
    text: 'ALL'
  }, {
    value: 'NOTPASS',
    text: 'NOTPASS'
  }, {
    value: 'FAIL',
    text: 'FAIL'
  }, {
    value: 'INCONCLUSIVE',
    text: 'INCONCLUSIVE'
  }];

  testLabOption = [
    {
      value: 'Local',
      text: 'Local'
    }, {
      value: 'SauceLab',
      text: 'SauceLab'
    }, {
      value: 'Perfecto',
      text: 'Perfecto',
    }, {
      value: 'Headspin',
      text: 'Headspin',
    }, {
      value: 'Browserstack',
      text: 'Browserstack',
    }
  ];
  
  searchString: string = '';
  unmaskedValue: any;
  nonEmptyFeildsData: any;
  enableEditPopup: boolean = false;
  feildValue: any;
  fieldName: any;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  updateLocatorFlag: boolean;
  selectedDb: string = "default";
  selectedDbIndex : number = 0;
  settingCreateForm: UntypedFormGroup;
  nonDeleteSettingsList = [];
  @ViewChild('cancelNewSettingModal', null) cancelNewSettingModal: ElementRef;


  testEnvPerpageitem = beatBlipSubscriptionConsts.perpageitem;
  testEnvCurrentPage : number = 1;
  testEnvSelectedPage: any;

  appPerpageitem = beatBlipSubscriptionConsts.perpageitem;
  appCurrentPage : number = 1;
  appSelectedPage: any;

  customPerpageitem = beatBlipSubscriptionConsts.perpageitem;
  customCurrentPage : number = 1;
  customSelectedPage: any;
  AllSettings: any;

  allSettingPerpageitem = beatBlipSubscriptionConsts.perpageitem;
  allSettingCurrentPage : number = 1;
  allSettingSelectedPage: any;
  currentUrl: any;
  previousUrltemp: any;
  agentCheck: boolean;


  constructor(
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
    private setting: SettingService,
    private urlService: UrlService,
    private router:Router,
    private memoryService: MemoryService,
    private homeService: HomeService,
    @Inject(DOCUMENT) private document: Document,
  ) { }
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  @ViewChild('cancelAddCustom', null) cancelAddCustom: ElementRef;
  previousUrl:any = [];
  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
            this.getAllprojectSetting(this.projectId);
            this.getProjectTypeDetails(this.projectData.projectType);
            //console.log('project data', this.projectData);
            this.getUnmaskable();
            this.getNonEmptyFeilds();
            this.getNonDeleteSetting();
          }
        ))

      }
    )

    this.initNewSettingForm();
   
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  initNewSettingForm() {
    this.settingCreateForm = this.formBuilder.group({
      settingName: ['', Validators.required]
    });
  }

  onCreateSetting() {
    let formValue = this.settingCreateForm.value;
    let settingNames = [];
    this.dbSettingData.forEach((data) => {
      settingNames.push(data.name);
    })
    //console.log("inside create setting", formValue, settingNames);
    if (settingNames.includes(formValue.settingName)) {
      this.toastrService.clear();
      this.toastrService.warning("Database setting name should be unique");
      return;
    }

    let obj = { "name": formValue.settingName, "type": "DB", "setting": { "entry": [{ "key": "dbname", "value": { "settingValue": "", "maskedValue": "", "isMasked": "false" } }, { "key": "driver", "value": { 'fieldType' :  "dropdown" ,"settingValue": "SQLServerDriver", "maskedValue": "SQLServerDriver", "isMasked": "false", "values" : ["MongoDriver", "MySQLDriver", "SQLServerDriver", "SQLServerDriverWA","SQLServerDriverAAD", "InfluxDriver", "OracleDriver", "DB2Driver", "CassandraDriver", "HanaDriver", "SnowflakeServerDriver", "AzureSynpaseDriver" ] } }, { "key": "password", "value": { "settingValue": "", "maskedValue": "", "isMasked": "true" } }, { "key": "schemaname", "value": { "settingValue": "", "maskedValue": "", "isMasked": "false" } }, { "key": "server", "value": { "settingValue": "", "maskedValue": "", "isMasked": "false" } }, { "key": "timezone", "value": { "settingValue": "UTC", "maskedValue": "UTC", "isMasked": "false" } }, { "key": "username", "value": { "settingValue": "", "maskedValue": "", "isMasked": "false" } }] } }

    this.setting.addSetting(this.projectId, obj).subscribe((res) => {
      this.cancelNewSettingModal.nativeElement.click();
      this.selectedDb = "default";
      this.getAllprojectSetting(this.projectId);
      this.toastrService.clear();
      this.toastrService.success("Database setting is save successfully");
    })

  }

  deleteSetting(settingName) {
    //console.log(settingName, this.dbSettingData, this.selectedDbIndex);
    let selectedSetting = this.dbSettingData.filter((data) => data.name == settingName);
    //console.log(selectedSetting);
    let obj = _.pick(selectedSetting[0], ['id', 'name', 'setting', 'type']);
    //console.log(obj);

    this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + settingName + ' ?')
    .afterClosed().subscribe(res => {
      if (res) {
        this.setting.deleteSetting(this.projectId, obj).subscribe((res) => {
          this.selectedDb = "default";
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success("Database setting is deleted successfully");
        })
      }
    });

  }

  getProjectTypeDetails(projectType) {
    if (projectType === "MOBILE") {
      var mobileType = this.projectData['projectSettingList'][3]
      this.testEnvSettingData = mobileType;
      //console.log('mobile', mobileType);
    }
    if (projectType === "DESKTOP") {
      var desktopType = this.projectData['projectSettingList'][5]
      this.testEnvSettingData = desktopType;
      //console.log('mobile', desktopType);
    }
  }

  getUnmaskable() {
    this.setting.getUnMaskedValue().subscribe(
      (data) => {
        this.unmaskedValue = data['unmaskableField'];
        //console.log(this.unmaskedValue)
      }
    )
  }

  getNonDeleteSetting() {
    this.setting.getNonDeleteSetting().subscribe((res) => {
      this.nonDeleteSettingsList = res['nondeletesettings'];
    })
  }

  showDeleteOption(key) {
    if (this.nonDeleteSettingsList.includes(key.toUpperCase())) {
      return false;
    }
    else {
      return true;
    }
  }

  showCustomDeleteOption(key) {
    let showDelete : boolean = true;
    this.testEnvSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        showDelete = false
      }
    });

    this.applicationSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        showDelete = false
      }
    });

    if (this.nonDeleteSettingsList.includes(key.toUpperCase())) {
      showDelete = false
    }

    return showDelete;
  }


  checkMaskable(key) {
    return this.unmaskedValue.includes(key);
  }

  getUnmasked(key) {
    if (this.unmaskedValue.includes(key)) {
      return true
    }
    else {
      return false;
    }
  }
  getMaskedValue(key, value) {

    //console.log(key, 'value>', value);
    if (value.trim() === '') {
      this.toastrService.clear();
      this.toastrService.info('Empty Value cannot be Encrypted');
      return;
    }


    if (this.updateTestEnvData) {
      // this.updateTestEnvData = true;
      this.updateSettingData = this.testEnvSettingData.setting.entry.filter((f) => f.key == key)
      console.log(this.updateSettingData)
      if (this.updateSettingData[0].value.isMasked == 'true') {
        this.updateSettingData[0].value.isMasked = 'false';
        this.setting.decryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {
            console.log(data);
            this.updateSettingData[0].value = data
            this.project.editProjectSetting(this.projectId, this.testEnvSettingData).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting decrypted successfully');
              }
            )
          }
        )

        //console.log('if>', this.updateSettingData);
      }
      else if (this.updateSettingData[0].value.isMasked == 'false') {
        this.updateSettingData[0].value.isMasked = 'true';
        //console.log('else if>', this.updateSettingData);

        this.setting.encryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {

            this.updateSettingData[0].value = data
            console.log(data);
            this.project.editProjectSetting(this.projectId, this.testEnvSettingData).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting encrypted successfully');
              }
            )

          }
        )
      }

    }
    if (this.updateApplicationData) {
      this.updateApplicationData = true;
      console.log(this.applicationSettingData)
      this.updateSettingData = this.applicationSettingData.setting.entry.filter((f) => f.key == key)
      if (this.updateSettingData[0].value.isMasked == 'true') {
        this.updateSettingData[0].value.isMasked = 'false';
        this.setting.decryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {
            console.log(data);
            this.updateSettingData[0].value = data
            this.project.editProjectSetting(this.projectId, this.applicationSettingData).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting decrypted successfully');
              }
            )
          })
        //console.log('if>', this.updateSettingData);
      }
      else if (this.updateSettingData[0].value.isMasked == 'false') {
        this.updateSettingData[0].value.isMasked = 'true';
        //console.log('else if>', this.updateSettingData);
        this.setting.encryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {

            this.updateSettingData[0].value = data
            console.log(data);
            this.project.editProjectSetting(this.projectId, this.applicationSettingData).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting encrypted successfully');
              }
            )

          }
        )
      }
 

    }
    if (this.updateCustomData) {
      this.updateCustomData = true;
      this.updateSettingData = this.customSettingData.setting.entry.filter((f) => f.key == key)
      console.log(this.updateSettingData);
      if (this.updateSettingData[0].value.isMasked == 'true') {
        this.updateSettingData[0].value.isMasked = 'false';
        //console.log('if>', this.updateSettingData);
        this.setting.decryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {
            console.log(data);
            this.updateSettingData[0].value = data
            this.project.editProjectSetting(this.projectId, this.customSettingData).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting decrypted successfully');
              }
            )
          })
      }
      else if (this.updateSettingData[0].value.isMasked == 'false') {
        this.updateSettingData[0].value.isMasked = 'true';
        this.setting.encryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {

            this.updateSettingData[0].value = data
            console.log(data);
            this.project.editProjectSetting(this.projectId, this.customSettingData).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting encrypted successfully');
              }
            )
          }
        )
        //console.log('else if>', this.updateSettingData);
      }
 

    }
    if (this.updateDbData) {
      this.updateDbData = true;
      this.updateSettingData = this.dbSettingData[this.selectedDbIndex].setting.entry.filter((f) => f.key == key)
      if (this.updateSettingData[0].value.isMasked == 'true') {
        this.updateSettingData[0].value.isMasked = 'false';
        // console.log('if>', this.updateSettingData);
        this.setting.decryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {
            console.log(data);
            this.updateSettingData[0].value = data
            this.project.editProjectSetting(this.projectId, this.dbSettingData[this.selectedDbIndex]).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting decrypted successfully');
              }
            )
          })
      }
      else if (this.updateSettingData[0].value.isMasked == 'false') {
        this.updateSettingData[0].value.isMasked = 'true';
        this.setting.encryptSetting(this.projectId, this.updateSettingData[0].value).subscribe(
          (data) => {

            this.updateSettingData[0].value = data
            console.log(data);
            this.project.editProjectSetting(this.projectId, this.dbSettingData[this.selectedDbIndex]).subscribe(
              (data) => {
                //console.log(data);
                this.toastrService.clear();
                this.toastrService.success('Automation setting encrypted successfully');
              }
            )
          }
        )
        //console.log('else if>', this.updateSettingData);
      }
   
     

    }

  }

  getNonEmptyFeilds() {
    this.setting.nonEmptyFeilds().subscribe(
      (data) => {
        this.nonEmptyFeildsData = data['nonemptyfields'];
        //console.log(this.nonEmptyFeildsData);
      }
    )
  }
  captureEvent(key, event: any) {
    console.log(key, event);
    var objectForEdit = {}
    objectForEdit[key] = event.target.checked.toString();
    //console.log(objectForEdit[key]);

    if (this.updateTestEnvData) {
      // this.updateTestEnvData = true;
      this.updateSettingData = this.testEnvSettingData.setting.entry.filter((f) => f.key == key)
      //console.log(this.updateSettingData)
    }
    if (this.updateApplicationData) {
      this.updateApplicationData = true;
      //console.log(this.applicationSettingData)
      this.updateSettingData = this.applicationSettingData.setting.entry.filter((f) => f.key == key)
    }
    if (this.updateCustomData) {
      this.updateCustomData = true;
      this.updateSettingData = this.customSettingData.setting.entry.filter((f) => f.key == key)
      //console.log(this.updateSettingData);
    }
    if (this.updateDbData) {
      this.updateDbData = true;
      this.updateSettingData = this.dbSettingData[this.selectedDbIndex].setting.entry.filter((f) => f.key == key)
    }
    this.formObj = objectForEdit;
    this.updateSettingData[0].value.settingValue = Object.values(this.formObj)[0];
    this.submitted = true;
    if (this.updateTestEnvData) {

      this.project.editProjectSetting(this.projectId, this.testEnvSettingData).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId)
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');

        }
      )
    }
    if (this.updateApplicationData) {
      this.project.editProjectSetting(this.projectId, this.applicationSettingData).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');
        }
      )
    }
    if (this.updateCustomData) {
      this.project.editProjectSetting(this.projectId, this.customSettingData).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');
        }
      )
    }
    if (this.updateDbData) {
      this.project.editProjectSetting(this.projectId, this.dbSettingData[this.selectedDbIndex]).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');
        }
      )
    }
  }

  updateSetting(event: any, fieldName) {
    this.feildValue = event.value;
    this.fieldName = fieldName;
    //console.log(this.feildValue);
    var objectForEdit = {}
    objectForEdit[fieldName] = this.feildValue.toString();
    //console.log(objectForEdit);

    if (this.updateTestEnvData) {
      // this.updateTestEnvData = true;
      this.updateSettingData = this.testEnvSettingData.setting.entry.filter((f) => f.key == fieldName)
      //console.log(this.updateSettingData)
    }
    if (this.updateApplicationData) {
      this.updateApplicationData = true;
      //console.log(this.applicationSettingData)
      this.updateSettingData = this.applicationSettingData.setting.entry.filter((f) => f.key == fieldName)
    }
    if (this.updateCustomData) {
      this.updateCustomData = true;
      this.updateSettingData = this.customSettingData.setting.entry.filter((f) => f.key == fieldName)
      //console.log(this.updateSettingData);
    }
    if (this.updateDbData) {
      this.updateDbData = true;
      this.updateSettingData = this.dbSettingData[this.selectedDbIndex].setting.entry.filter((f) => f.key == fieldName)
    }
    this.formObj = objectForEdit;
    this.updateSettingData[0].value.settingValue = Object.values(this.formObj)[0];
    this.submitted = true;
    if (this.updateTestEnvData) {
      this.project.editProjectSetting(this.projectId, this.testEnvSettingData).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');
        }
      )
    }
    if (this.updateApplicationData) {
      this.project.editProjectSetting(this.projectId, this.applicationSettingData).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');
        }
      )
    }
    if (this.updateCustomData) {
      this.project.editProjectSetting(this.projectId, this.customSettingData).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');
        }
      )
    }
    if (this.updateDbData) {
      this.project.editProjectSetting(this.projectId, this.dbSettingData[this.selectedDbIndex]).subscribe(
        (data) => {
          //console.log(data);
          this.getAllprojectSetting(this.projectId);
          this.toastrService.clear();
          this.toastrService.success('Automation setting updated successfully');
        }
      )
    }

  }

  getAllprojectSetting(projectId) {
    this.setting.getAllProjectSetting(projectId).subscribe(
      (data) => {
        this.projectSettingData = data['projectSettingList'];
        //console.log('allSettingData', this.projectSettingData);

        if (this.projectData.projectType === "MOBILE") {
          var mobileType = this.projectData['projectSettingList'][3]
          this.testEnvSettingData = mobileType;
          //console.log('mobile', mobileType);
        }
        else if (this.projectData.projectType === "DESKTOP") {
          var desktopType = this.projectData['projectSettingList'][5]
          this.testEnvSettingData = desktopType;
          //console.log('mobile', desktopType);
        }
        else
        {
          this.TestEnvData = this.projectSettingData.filter((f) => f.name == 'envSetting')
          this.testEnvSettingData = this.TestEnvData[0];  
        }

        this.testEnvSettingData.setting.entry.forEach(element => {
          //console.log(element);
          if (element.key == 'auto_heal') {
            if (element.value.settingValue == 'false') {
              //console.log('check for auto heal');

              this.updateLocatorFlag = true;
              //console.log(this.updateLocatorFlag, element.value.settingValue);
            }
            else {
              this.updateLocatorFlag = false;
            }



          }

        });
        this.applicationSettingData = this.projectSettingData.filter((f) => f.name == 'gSetting');
        this.applicationSettingData = this.applicationSettingData[0];
        this.customSettingData = this.projectSettingData.filter((f) => f.name == 'cSetting')
        this.customSettingData = this.customSettingData[0];
        this.dbSettingData = this.projectSettingData.filter((f) => f['@type'] == 'dbSetting')
        this.dbSettingData = this.dbSettingData;
        this.AllSettings = [];

        let clubedSettings = this.projectSettingData.filter((setting) => setting['@type'] == 'testEnvSetting' ||  setting['@type'] == 'customSetting' || setting['@type'] == 'globalSetting');
        clubedSettings.forEach((data)=>
        {
          data.setting.entry.forEach((setting)=>
          {
              this.AllSettings.push(setting);
          })
        })
        console.log("All ",this.AllSettings);
      }
    )
  }
  enableApplictionSettingtoUpdate() {
    this.updateApplicationData = true;
    this.updateTestEnvData = false;
    this.updateCustomData = false;
    this.updateDbData = false;
  }
  enableTestEnvSettingtoUpdate() {
    this.updateApplicationData = false;
    this.updateTestEnvData = true;
    this.updateCustomData = false;
    this.updateDbData = false;
  }
  enableCustomSettingtoUpdate() {
    this.updateApplicationData = false;
    this.updateTestEnvData = false;
    this.updateCustomData = true;
    this.updateDbData = false;
  }
  enableDbSettingtoUpdate() {
    this.updateApplicationData = false;
    this.updateTestEnvData = false;
    this.updateCustomData = false;
    this.updateDbData = true;
  }

  selectDb(selectedDb, index) {
    //console.log(selectedDb, index);
    this.selectedDb = selectedDb;
    this.selectedDbIndex = index;
  }
  
  filterBugLog(bugDataToEdit, bugDataValue, isMasked) {
    //console.log(this.dbSettingData, this.selectedDbIndex);
    this.bugDataToEdit = bugDataToEdit;
    this.bugDataValue = bugDataValue;
    this.isMasked =  isMasked;

    if (isMasked == 'true' && this.bugDataValue !='') {
      this.toastrService.clear();
      this.toastrService.info('please decrypt and then try to edit');
      return;
    }
    if (this.bugDataValue == 'false' || this.bugDataValue == 'true') {
      this.enableEditPopup = false;
      this.toastrService.clear();
      this.toastrService.info('Use toggle button for edit')
      return;
    }
    else if (this.bugDataToEdit == 'auto_heal_locator_timeout' || this.bugDataToEdit == 'locator_timeout' || this.bugDataToEdit == 'max_execution_retries') {
      this.enableEditPopup = false;
      this.toastrService.clear();
      this.toastrService.info('Kindly Change Value using Slider bar');
      return;
    }
    else if (this.bugDataToEdit == 'test_adapter_type') {
      this.toastrService.clear();
      this.toastrService.info('You are not allowed to update setting value');
      return;
    }
    else {
      $(document).ready(() => {
        $('#editSetting').modal('show');
      });
      this.enableEditPopup = true;
      if (this.updateTestEnvData) {
        // this.updateTestEnvData = true;
        this.updateSettingData = this.testEnvSettingData.setting.entry.filter((f) => f.key == bugDataToEdit)
        //console.log(this.updateSettingData)
      }
      if (this.updateApplicationData) {
        this.updateApplicationData = true;
        //console.log(this.applicationSettingData)
        this.updateSettingData = this.applicationSettingData.setting.entry.filter((f) => f.key == bugDataToEdit)
      }
      if (this.updateCustomData) {
        this.updateCustomData = true;
        this.updateSettingData = this.customSettingData.setting.entry.filter((f) => f.key == bugDataToEdit)
        //console.log(this.updateSettingData);
      }
      if (this.updateDbData) {
        this.updateDbData = true;
        this.updateSettingData = this.dbSettingData[this.selectedDbIndex].setting.entry.filter((f) => f.key == bugDataToEdit)
      }
    }

    // //console.log(this.settingTestEnvData);
    // if(bugDataToEdit=='bug_logging'){
    //   this.updateSettingData = this.bugLoggingSysData.filter((f)=>f.key.includes(bugDataToEdit));
    //   //console.log(this.updateSettingData);
    // }

  }

 validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .trim()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  onSubmit(editProjectSettingForm) {
    //console.log(editProjectSettingForm);
    this.formObj = editProjectSettingForm.value;
    //console.log(Object.values(this.formObj)[0]);
    //console.log(Object.keys(this.formObj)[0]);
    let selectedSettingKey = Object.keys(this.formObj)[0];
    let selectedSettingValue = editProjectSettingForm.value[selectedSettingKey];
    let isEmptyFieldsAllowed :  boolean = true;

    let mandatorySettingFields = ['browser', 'browsing_type', 'data_setting_name', 'culture', 'run_mode', 'screenshot_dir', 'test_adapter_type', 'output_data_file_format','suite_run_mode','data_manager_view', 'service_type', 'failed_execution_type' ];
    let driverList = ['chrome_driver', 'chrome_headless_driver',  'microsoft_edge_driver', 'opera_driver', 'phantomjs_headless_driver', 'firefox_driver', 'username', 'password','report_email_id'];

    mandatorySettingFields.forEach((element)=>
    {
      if(element == selectedSettingKey)
      {
          isEmptyFieldsAllowed = false
      }
    })

    // driverList.forEach((element)=>
    // {
    //   if(element == selectedSettingKey)
    //   {
    //       isEmptyFieldsAllowed = true
    //   }
    // })

    if(Object.keys(this.formObj)[0]=='report_email_id'){

      let emailIds : any = Object.values(this.formObj)[0];
      let list =  emailIds.split(",")
      let isEmailIdValid : boolean = true;
      list.forEach(element => {
        if(!this.validateEmail(element))
        {
          isEmailIdValid = false;
        }
      });
      
      if(!isEmailIdValid && emailIds!='' ){
        this.toastrService.clear();
        this.toastrService.warning('please enter valid email address');
        return;
      } 
    }

    if (selectedSettingValue.trim() == '' && !isEmptyFieldsAllowed) {
      this.toastrService.clear();
      this.toastrService.warning('Cannot save empty field');
      return;
    }

    this.updateSettingData[0].value.settingValue = Object.values(this.formObj)[0];
    this.submitted = true;
    if (this.updateTestEnvData) {
      this.editProjectSettings(this.projectId, this.testEnvSettingData);
    }

     // Add by Surendra
     var   runMode= ["parallel", "sequential"];
     var testrunModeValue=runMode.filter((f)=>f==(Object.values(this.formObj)[0]))
     //console.log(testrunModeValue);
    if(Object.keys(this.formObj)[0]=='suite_run_mode'){
      if(testrunModeValue.length<1){
        this.toastrService.clear();
        this.toastrService.warning('Please select a valid Suite Run Mode');
        return;
      }     
    }
    
    if (this.updateApplicationData) {
      this.editProjectSettings(this.projectId, this.applicationSettingData);
    }
    if (this.updateCustomData) {
      this.editProjectSettings(this.projectId, this.customSettingData);
    }
    if (this.updateDbData) {
      this.editProjectSettings(this.projectId, this.dbSettingData[this.selectedDbIndex]);
    }
    this.enableEditPopup = false;
    this.cancelmodal.nativeElement.click();
  }

  editProjectSettings(projectId, settingData)
  {
    let selectedSetting = settingData.setting.entry.find((f) => f.key == this.bugDataToEdit)

    if (!this.isMasked) {
        this.project.editProjectSetting(projectId, settingData).subscribe(
            (data) => {
              //console.log(data);
              this.toastrService.clear();
              this.toastrService.success('Automation setting saved successfully');
            }
        )
      //console.log('if>', this.updateSettingData);
    }
    else if (this.isMasked) {

      this.setting.encryptSetting(projectId, selectedSetting.value).subscribe(
        (data) => {

          selectedSetting.value = data
          console.log(data);
          this.project.editProjectSetting(this.projectId, settingData).subscribe(
            (data) => {
              //console.log(data);
              this.toastrService.clear();
              this.toastrService.success('Automation setting saved successfully');
            }
          )

        }
      )
    }

  }

  onAddCustomSetting(addCustomSettingForm) {
    let isSettingExist = false;
    if(addCustomSettingForm.value.settingName=='' || addCustomSettingForm.value.settingName == null)
    {
      this.toastrService.clear();
      this.toastrService.warning("Setting name cannot be empty");
      return;
    }
    this.customSettingData.setting.entry.forEach((data) => {
      if (data.key == addCustomSettingForm.value.settingName) {
        isSettingExist = true;
      }
    })

    this.testEnvSettingData.setting.entry.forEach(element => {
      if(element.key == addCustomSettingForm.value.settingName)
      {
        isSettingExist = true;
      }
    });

    this.applicationSettingData.setting.entry.forEach(element => {
      if(element.key == addCustomSettingForm.value.settingName)
      {
        isSettingExist = true;
      }
    });
    
    // add by surendra
      let whiteSpace = addCustomSettingForm.value.settingName;
      let noWhiteSpace = whiteSpace.trim();
    if (noWhiteSpace =='') {
      this.toastrService.clear();
      this.toastrService.warning("Setting name cannot be empty");
      return;
    }
    if (isSettingExist) {
      this.toastrService.clear();
      this.toastrService.warning("Duplicate setting not allowed");
      return;
    }
    //console.log(addCustomSettingForm.value);
    var objectForAdd = {};
    objectForAdd['key'] = addCustomSettingForm.value.settingName;
    objectForAdd['value'] = {
      settingValue: addCustomSettingForm.value.settingValue,
      isMasked: 'false'
    }
    //console.log(objectForAdd);

    this.customSettingData.setting.entry.push(objectForAdd);
    //console.log(this.customSettingData);

    this.project.editProjectSetting(this.projectId, this.customSettingData).subscribe(
      (data) => {
        //console.log(data);
        this.getAllprojectSetting(this.projectId);
        addCustomSettingForm.reset();
        this.cancelAddCustom.nativeElement.click();
        this.toastrService.clear();
        this.toastrService.success('Automation setting updated successfully');
      }
    )
  }

  onDeleteCustomSetting(key) {
    //console.log(key, this.customSettingData.setting.entry);
    this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + key + ' ?')
      .afterClosed().subscribe(res => {
        if(res)
        {
          this.customSettingData.setting.entry.forEach((element, i) => {
            if (element.key == key) {
              this.customSettingData.setting.entry.splice(i, 1);
            }
          });
          let body = _.pick(this.customSettingData, ['id', 'name', 'setting', 'type']);
          this.project.editProjectSetting(this.projectId, body).subscribe((res) => {
            this.toastrService.clear();
            this.toastrService.success("Setting deleted successfully");
            this.getAllprojectSetting(this.projectId);
          })
        }
       
      });
  }


  onPageChange(newValue) {
    this.selectedPage = 1;
    this.perpageitem = newValue;
  }

  onCustomPageChange(newValue) {
    this.customSelectedPage = 1;
    this.customPerpageitem = newValue;
  }

  onTestEnvPageChange(newValue) {
    this.testEnvSelectedPage = 1;
    this.testEnvPerpageitem = newValue;
  }

  onAppPageChange(newValue) {
    this.appSelectedPage = 1;
    this.appPerpageitem = newValue;
  }

  onCubbedPageChange(newValue)
  {
    this.allSettingSelectedPage = 1;
    this.allSettingPerpageitem =  newValue;
  }


  testDbConnection(dbSettingName)
  {
      this.setting.testConnection(this.projectId, dbSettingName).subscribe((response)=>
      {
        if(response['list'] && response['list'] === 'false')
        {
            this.toastrService.clear();
            this.toastrService.error("Unable to connect to database");
        }
        else
        {
          this.toastrService.clear();
          this.toastrService.success("Connection successful");
        }
      })
  }

  captureAllSettingEvent(key ,event)
  {
    let fieldtype = '';
    this.testEnvSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        fieldtype = 'testEnv'
      }
    });

    this.applicationSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        fieldtype = 'appSetting'
      }
    });

    this.customSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        fieldtype = 'cSetting'
      }
    });

    switch(fieldtype)
    {
      case 'testEnv':
        this.enableTestEnvSettingtoUpdate();
        this.captureEvent(key, event);
        break;
      case 'appSetting':
        this.enableApplictionSettingtoUpdate();
        this.captureEvent(key, event);
        break;
      case 'cSetting':
        this.enableCustomSettingtoUpdate();
        this.captureEvent(key, event);
        break;
      default:
        break;
    }
  }

  updateCustomSetting(event, key)
  {
    let fieldtype = '';
    this.testEnvSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        fieldtype = 'testEnv'
      }
    });

    this.applicationSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        fieldtype = 'appSetting'
      }
    });

    this.customSettingData.setting.entry.forEach(element => {
      if(element.key == key)
      {
        fieldtype = 'cSetting'
      }
    });

    switch(fieldtype)
    {
      case 'testEnv':
        this.enableTestEnvSettingtoUpdate();
        this.updateSetting(event, key);
        break;
      case 'appSetting':
        this.enableApplictionSettingtoUpdate();
        this.updateSetting(event, key);
        break;
      case 'cSetting':
        this.enableCustomSettingtoUpdate();
        this.updateSetting(event, key);
        break;
      default:
        break;
    }

  }

  filterCustomBugLog(bugDataToEdit, bugDataValue,isMasked)
  {
  
    let fieldtype = '';
    this.testEnvSettingData.setting.entry.forEach(element => {
      if(element.key == bugDataToEdit)
      {
        fieldtype = 'testEnv'
      }
    });

    this.applicationSettingData.setting.entry.forEach(element => {
      if(element.key == bugDataToEdit)
      {
        fieldtype = 'appSetting'
      }
    });

    this.customSettingData.setting.entry.forEach(element => {
      if(element.key == bugDataToEdit)
      {
        fieldtype = 'cSetting'
      }
    });

    switch(fieldtype)
    {
      case 'testEnv':
        this.enableTestEnvSettingtoUpdate();
        this.filterBugLog(bugDataToEdit, bugDataValue,isMasked)
        break;
      case 'appSetting':
        this.enableApplictionSettingtoUpdate();
        this.filterBugLog(bugDataToEdit, bugDataValue,isMasked)
        break;
      case 'cSetting':
        this.enableCustomSettingtoUpdate();
        this.filterBugLog(bugDataToEdit, bugDataValue,isMasked)
        break;
      default:
        break;
    }
    
  }

  getCustomMaskedValue(bugDataToEdit, bugDataValue)
  {
    let fieldtype = '';
    this.testEnvSettingData.setting.entry.forEach(element => {
      if(element.key == bugDataToEdit)
      {
        fieldtype = 'testEnv'
      }
    });

    this.applicationSettingData.setting.entry.forEach(element => {
      if(element.key == bugDataToEdit)
      {
        fieldtype = 'appSetting'
      }
    });

    this.customSettingData.setting.entry.forEach(element => {
      if(element.key == bugDataToEdit)
      {
        fieldtype = 'cSetting'
      }
    });

    switch(fieldtype)
    {
      case 'testEnv':
        this.enableTestEnvSettingtoUpdate();
        this.getMaskedValue(bugDataToEdit, bugDataValue)
        break;
      case 'appSetting':
        this.enableApplictionSettingtoUpdate();
        this.getMaskedValue(bugDataToEdit, bugDataValue)
        break;
      case 'cSetting':
        this.enableCustomSettingtoUpdate();
        this.getMaskedValue(bugDataToEdit, bugDataValue)
        break;
      default:
        break;
    }
    
  }

  resetNewSettingForm(addCustomSettingForm)
  {
    addCustomSettingForm.form.reset();
  }

}